module.exports = __webpack_public_path__ + "static/img/405.63e6711.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/405.png
// module id = 524
// module chunks = 3